import jQuery from 'jquery';

export default () => {
  Object.assign(window, {
    jQuery,
    $: jQuery,
  });
};
